import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const configurationAdminOverrideSchema = z.object({
  group: z.string(),
  key: z.string(),
  value: z.string(),
  modifiedOn: coercedDate,
});

export type ConfigurationAdminOverride = z.infer<
  typeof configurationAdminOverrideSchema
>;
